import { api, authorizedFetch } from '@/shared/api/api-client';
import { ENDPOINTS } from '@/shared/api/endpoints';

/** Metadata for the authenticated user's universal account avatar. */
export interface AvatarMetadata {
  exists: boolean;
  contentType: string | null;
  sizeBytes: number | null;
  updatedAt: string | null;
}

export function getAccountAvatarMetadata(): Promise<AvatarMetadata> {
  return api().get<AvatarMetadata>(ENDPOINTS.account.avatar);
}

export function uploadAccountAvatar(file: File): Promise<AvatarMetadata> {
  const body = new FormData();
  body.append('file', file);
  return api().put<AvatarMetadata>(ENDPOINTS.account.avatar, body);
}

export function deleteAccountAvatar(): Promise<AvatarMetadata> {
  return api().delete<AvatarMetadata>(ENDPOINTS.account.avatar);
}

/**
 * Fetch the avatar bytes (served raw, not JSON-wrapped) as an object URL the
 * caller can use as an `<img src>`. Returns null when no avatar exists (404).
 * The caller owns revoking the URL.
 */
export async function fetchAccountAvatarObjectUrl(): Promise<string | null> {
  const response = await authorizedFetch(ENDPOINTS.account.avatarRaw);
  if (!response.ok) {
    return null;
  }
  const blob = await response.blob();
  return URL.createObjectURL(blob);
}
